module.exports = {"component":"modal","status":"prod","display-name":"Modals and Prompts","SLDS-component-path":"/components/modals","url-slug":"modals"}


//////////////////
// WEBPACK FOOTER
// ./components/modal/docs.json
// module id = 150
// module chunks = 0